<template>
  <div class="process-list">
    <Toolbar :handle-back="() => back()" class="nobackground">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50">
          <h1><v-icon large>mdi-book</v-icon>{{ $t('process.documentations') }} -
            <span v-if="item">
              <span v-if="language == 'fr'">{{ item.namefr }}</span>
              <span v-else>{{ item.name }}</span>
            </span>
          </h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <v-container grid-list-xl fluid>
      <v-layout row wrap>

        <v-flex lg12>
          <v-container>
            <v-row class="">
              <v-col cols="12" sm="12" md="6" v-for="process in processSelectItems" :key="process.id"
                class="d-flex align-self-stretch">
                <v-card color="" dark class="ma-3 cursorpointer" width="100%" @click="showProcess(process)"
                  v-on:click.right="showProcessExt(process)">
                  <div v-if="isNew(process.updated, 86400)" class="corner corner-accent d-flex flex-row-reverse">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">UPDATE</span>
                      </template>
                      <span>{{ $t('global.updated') }}</span>
                    </v-tooltip>
                  </div>
                  <v-row>
                    <v-col cols="12" sm="4" md="4">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <div v-bind="attrs" v-on="on">
                            <v-img v-bind="attrs" v-on="on" v-if="process.image" height="150px" width="150px"
                              aspect-ratio="1" class="white--text align-end ma-5 medium_logo"
                              :key="getItemImageKey(process)" :src="getImageUrlByObject(process)">
                            </v-img>
                            <v-img v-else height="150px" width="150px" aspect-ratio="1"
                              class="ma-5 secondary--text align-center align-end cursorpointer  text-center">
                              <p class="textsize20 text-uppercase ma-1 familyGTAmerica">{{ $t('global.nopicture')
                                }}<br>{{ $t('global.available') }}</p>
                            </v-img>
                          </div>
                        </template>
                        <span v-if="process['id']">{{ $t('global.number') }} {{ process.number }}</span>
                      </v-tooltip>
                    </v-col>
                    <v-col cols="12" sm="8" md="8">
                      <v-card-title class="text-h5 primary--text mr-10 word-nobreak">

                        <span v-if="language == 'fr'">{{ process.namefr }}</span>
                        <span v-else>{{ process.name }}</span>
                      </v-card-title>
                      <v-card-subtitle>
                        <span class="mr-1 font-weight-black">{{ $t('global.number') }}{{ process.number }}</span><br>
                        <span v-if="language == 'fr'">{{ process.descriptionfr }}</span>
                        <span v-else>{{ process.description }}</span>
                      </v-card-subtitle>
                    </v-col>
                  </v-row>
                  <v-card-text class="align-top pt-0 pb-0 pl-5 pr-5">
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <span v-for="product in process['productModel']" :key="product"
                          class="text-right mr-2 font-weight-bold white--text familyGothamPro">
                          {{ product }}
                        </span>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions class="bordertop_white pl-5 pr-5">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on" class="d-inline-flex">
                          <v-sheet color="primary" outlined class="mr-1" height="10" width="10"></v-sheet>
                          <v-sheet v-if="process.intensity >= 2" color="primary" outlined class="ml-1 mr-1" height="10"
                            width="10"></v-sheet>
                          <v-sheet v-else color="secondary" outlined class="ml-1 mr-1" height="10" width="10"></v-sheet>
                          <v-sheet v-if="process.intensity >= 3" color="primary" outlined class="ml-1 mr-1" height="10"
                            width="10"></v-sheet>
                          <v-sheet v-else color="secondary" outlined class="ml-1 mr-1" height="10" width="10"></v-sheet>
                        </span>
                      </template>
                      <span>{{ $t('process.intensity') }}</span>
                    </v-tooltip>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on" class="d-inline-flex">
                          <v-icon class="mr-1">mdi-clock</v-icon> {{ displayTime(process.time * 60) }}
                        </span>
                      </template>
                      <span>{{ $t('process.time') }}</span>
                    </v-tooltip>
                    <v-spacer></v-spacer>
                    <v-btn icon 
                      @click.stop="exportProcess(process)"
                    >
                      <v-icon>mdi-export</v-icon>
                    </v-btn>
                    <v-btn icon @click="showProcess(process)" v-on:click.right="showProcessExt(process)">
                      <v-icon>mdi-launch</v-icon>
                    </v-btn>
                  </v-card-actions>

                </v-card>

              </v-col>
            </v-row>
          </v-container>
        </v-flex>
      </v-layout>
    </v-container>
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import i18n from '../../i18n.js';
import { displayTime, isNew } from '../../utils/dates';
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import ShowMixin from '../../mixins/ShowMixin';
import FileMixin from '../../mixins/FileMixin';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';

export default {
  name: 'ProcessListByType',
  servicePrefix: 'Process',
  mixins: [ListMixin, FileMixin, ShowMixin],
  components: {
    Loading,
    Toolbar
  },
  data() {
    return {
      filter: '250x250'
    };
  },
  mounted() {
    this.processGetSelectItems({ 'query': [{ 'id': 'enabled', 'value': 1 }, { 'id': 'types[]', 'value': this.$route.params.id }], 'orderCol': 'order[number]', 'order': 'asc' });
  },
  computed: {
    isLoading() {
      return (
        this.isLoading_process
      );
    },
    ...mapFields('processtype', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('processtype', ['find']),

    ...mapFields('process', {
      processSelectItems: 'selectItems',
      isLoading_process: 'isLoading'
    }),
    language() {
      return i18n.locale;
    }
  },
  methods: {
    ...mapActions({
      processActionDownload: 'process/actionDownload',
    }),
    exportProcess(process){
      let id = process['id'];
      let route = 'exportprocess/' + id;
        this.processActionDownload({action: route,name: 'exportprocess', values: {}});
    },
    ...mapActions({
      processGetSelectItems: 'process/fetchSelectItems'
    }),
    ...mapActions('processtype', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    }),
    ...mapGetters('exportprocess', {
      downloadItem: 'fetchAll',
    }),
    showProcess(process) {
      if (process['@id']) {
        this.$router.push({ name: `ProcessShow`, params: { id: process['@id'] } });
      }
    },
    showProcessExt(process) {
      let routeData = this.$router.resolve({
        name: `ProcessShow`,
        params: { id: process['@id'] }
      });
      window.open(routeData.href, '_blank');
    },

    back() {
      this.$router.push({ name: `ProcessListType` });
    },
    displayTime,
    isNew

  }
};
</script>
<style>
.corner {
  position: relative;
  line-height: 0px;
}

.corner:before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  border-top: 100px solid #2d4ea2;
  border-bottom: 100px solid transparent;
  border-left: 100px solid transparent;
  width: 0;
  z-index: 1;
}

.corner-primary:before {
  border-top: 100px solid #fdb913;
}

.corner-accent:before {
  border-top: 100px solid #2d4ea2;
}

.corner span {
  position: relative;
  top: 35px;
  width: 100px;
  right: 0px;
  left: 20px;
  text-align: center;
  font-size: 16px;
  margin-right: 7px;
  transform: rotate(45deg);
  display: block;
  z-index: 2;
}

.corner-accent span {
  margin-right: 0px;
}

.medium_logo {
  max-width: 150px;
}

@media screen and (max-width: 600px) {
  .medium_logo {
    max-width: none;
  }
}
</style>